import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/builders/$builder_id/communities/$community_id/plans")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/builders/$builder_id/locations/$location_id/location-plans",
      params: { builder_id: params.builder_id, location_id: params.community_id },
      statusCode: 301,
    });
  },
});
